import React, { useState, useEffect } from "react";
import axios from "axios";

import './MonitorPage.css';
import RoomMonitorQueue from './roomMonitorQueue';
import { getAllRooms } from '../../clientServices/RoomService';
import useMonitorSocket from '../../clientServices/MonitorSocket';
import MonitorMessages from './MonitorMessages';
const MonitorPage = () => {
    const [showImages, setShowImages] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [rooms, setRooms] = useState([]);
    const [messages, setMessages] = useState([]);




    const fetchRooms = async () => {
        try {
            const response = await getAllRooms();
            const activeRooms = response.data.filter(room => room.Status === true);
            // console.log(activeRooms);
            setRooms(activeRooms);
        } catch (error) {
            console.error('Error fetching rooms:', error);
        }
    };

    const { subscribeToRoom, queuesByRoom, socket } = useMonitorSocket(messages, setMessages, fetchRooms);

    useEffect(() => {
        fetchRooms();
    }, []);


    const fetchImages = async () => {
        try {
            const response = await axios.get("https://medical-center-znya.onrender.com/cloudinary/images");
            setImages(response.data || []);
        } catch (err) {
            setError("Failed to fetch images");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    useEffect(() => {
        let imageInterval;
        let mainPageTimeout;

        if (showImages) {
            imageInterval = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length); // מעבר לתמונה הבאה
            }, 5000); // שינוי התמונה כל 5 שניות

            mainPageTimeout = setTimeout(() => {
                setShowImages(false); // אחרי 20 שניות, נציג את MonitorView
            }, 15000);
        }

        return () => {
            clearInterval(imageInterval);
            clearTimeout(mainPageTimeout);
        };
    }, [showImages, images]);

    useEffect(() => {
        const mainPageInterval = setInterval(() => {
            setShowImages(true);
            setCurrentImageIndex(0); // אתחול של התמונה הראשונה
            console.log("Switching back to MonitorView...");
        }, 90000); // כל 20 שניות, נציג את התמונות מחדש

        return () => clearInterval(mainPageInterval);
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    if (images.length === 0) return <div>No images found</div>;

    const renderImages = () => (
        <div className="imagesContainer">
            {images.map((image, index) => (
                <img
                    key={index}
                    className={`imgFade ${index === currentImageIndex ? "fadeInClass" : ""}`}
                    src={image.secure_url}
                    alt={`Slide ${index}`}
                />
            ))}
        </div>
    );

    return (
        <div className="monitor-page">
            {showImages ? renderImages() : (<div className="monitorPageContainerFull">

                <div className='monitorPageContainer'>
                    <div className='queuesRoomsMonitorContainerBig'>
                        <div className='queuesRoomsMonitorContainer'>
                            {rooms.length > 0 ? (
                                rooms.map((room) => (
                                    <div key={room.ID} className='roomMonitorContainer'>
                                        <RoomMonitorQueue
                                            id={room.ID}
                                            name={room.Name}
                                            number={room.RoomNumber}
                                            subscribeToRoom={subscribeToRoom}
                                            queuesByRoom={queuesByRoom}
                                            socket={socket}
                                        />
                                    </div>
                                ))
                            ) : (
                                <p>No rooms available.</p>
                            )}
                        </div>
                    </div>
                    <MonitorMessages messages={messages} setMessages={setMessages} />

                </div>
            </div>)}
        </div>
    );
};

export default MonitorPage;
